import React from 'react';
import PropTypes from 'prop-types';

const Tab = ({label, activeTab, onClick}) => {
  const onClickHandler = () => {
    onClick(label);
  };

  return (
    <li
      className={`tab util-txt-center ${activeTab === label ? 'active' : ''}`}
      onClick={onClickHandler}
    >
      {label}
    </li>
  );
};

Tab.propTypes = {
  activeTab: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  label: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Tab;




// WEBPACK FOOTER //
// ./js/components/global/tabs/Tab.js